import { render, staticRenderFns } from "./Landcover.vue?vue&type=template&id=4d6b109a"
import script from "./Landcover.vue?vue&type=script&lang=js"
export * from "./Landcover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports